import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
//Imports from common
import { logout } from "./common/helpers/auth";
import * as pr from "./common/PrimeComponents";

export class MasterTopbar extends Component {
  static defaultProps = {
    onMenuButtonClick: null,
    onTopbarMenuButtonClick: null,
    onTopbarItemClick: null,
    profileMode: null,
    horizontal: true,
    topbarMenuActive: true,
    activeTopbarItem: null,
    onRightPanelButtonClick: null
  };

  static propTypes = {
    onMenuButtonClick: PropTypes.func.isRequired,
    onTopbarMenuButtonClick: PropTypes.func.isRequired,
    onTopbarItemClick: PropTypes.func.isRequired,
    profileMode: PropTypes.string.isRequired,
    horizontal: PropTypes.bool.isRequired,
    topbarMenuActive: PropTypes.bool.isRequired,
    activeTopbarItem: PropTypes.string,
    onRightPanelButtonClick: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = {
      visibleTop: false,
      logoutDialog: false,
      companyItems: [
        // {
        //   label: "Settings",
        //   icon: "power_settings_new",
        //   location: "#/settings"
        // },
        {
          label: "Permissions",
          icon: "domain",
          location: "#/permissions"
        },
        {
          label: "Users",
          icon: "room",
          location: "#/users"
        },
        {
          label: "Billing Management",
          icon: "room",
          location: "#/employees"
        }
      ],
      warehouseItems: [
        {
          label: "Attributes",
          icon: "power_settings_new",
          location: "#/attributes"
        },
        {
          label: "Attribute Sets",
          icon: "domain",
          location: "#/attributeSets"
        },
        {
          label: "Sites",
          icon: "room",
          location: "#/sites"
        },
        {
          label: "Catalogues",
          icon: "room",
          location: "#/catalogues"
        },
        {
          label: "Parts",
          icon: "room",
          location: "#/parts"
        },
        {
          label: "Products",
          icon: "room",
          location: "#/products"
        },
        {
          label: "Stations",
          icon: "room",
          location: "#/stations"
        }
      ],
      toolItems: [
        {
          label: "Help",
          icon: "room",
          location: "#/catalogues",
          externalLink:
            "https://bpmbuild.atlassian.net/servicedesk/customer/portals"
        }
      ],
      items: [
        {
          label: "File",
          icon: "pi pi-fw pi-file",
          items: [
            {
              label: "New",
              icon: "pi pi-fw pi-plus",
              items: [
                {
                  label: "Bookmark",
                  icon: "pi pi-fw pi-bookmark"
                },
                {
                  label: "Video",
                  icon: "pi pi-fw pi-video"
                }
              ]
            },
            {
              label: "Delete",
              icon: "pi pi-fw pi-trash"
            },
            {
              separator: true
            },
            {
              label: "Export",
              icon: "pi pi-fw pi-external-link"
            }
          ]
        },
        {
          label: "Edit",
          icon: "pi pi-fw pi-pencil",
          items: [
            {
              label: "Left",
              icon: "pi pi-fw pi-align-left"
            },
            {
              label: "Right",
              icon: "pi pi-fw pi-align-right"
            },
            {
              label: "Center",
              icon: "pi pi-fw pi-align-center"
            },
            {
              label: "Justify",
              icon: "pi pi-fw pi-align-justify"
            }
          ]
        },
        {
          label: "Users",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: "New",
              icon: "pi pi-fw pi-user-plus"
            },
            {
              label: "Delete",
              icon: "pi pi-fw pi-user-minus"
            },
            {
              label: "Search",
              icon: "pi pi-fw pi-users",
              items: [
                {
                  label: "Filter",
                  icon: "pi pi-fw pi-filter",
                  items: [
                    {
                      label: "Print",
                      icon: "pi pi-fw pi-print"
                    }
                  ]
                },
                {
                  icon: "pi pi-fw pi-bars",
                  label: "List"
                }
              ]
            }
          ]
        },
        {
          label: "Events",
          icon: "pi pi-fw pi-calendar",
          items: [
            {
              label: "Edit",
              icon: "pi pi-fw pi-pencil",
              items: [
                {
                  label: "Save",
                  icon: "pi pi-fw pi-calendar-plus"
                },
                {
                  label: "Delete",
                  icon: "pi pi-fw pi-calendar-minus"
                }
              ]
            },
            {
              label: "Archieve",
              icon: "pi pi-fw pi-calendar-times",
              items: [
                {
                  label: "Remove",
                  icon: "pi pi-fw pi-calendar-minus"
                }
              ]
            }
          ]
        },
        {
          separator: true
        },
        {
          label: "Quit",
          icon: "pi pi-fw pi-power-off"
        }
      ]
    };
  }

  onTopbarItemClick(event, item) {
    if (this.props.onTopbarItemClick) {
      this.props.onTopbarItemClick({
        originalEvent: event,
        item: item
      });
    }
  }

  navigateAdminOption = location => {
    this.setState({ visibleTop: false });
    window.location = location;
  };

  getLogoutDialog = () => {
    const s = this.state;
    return (
      <pr.Dialog
        header="Logging out"
        footer={
          <div>
            <pr.Button
              className="secondary-btn"
              label="Yes"
              icon="pi pi-check"
              onClick={() => {
                logout();
                localStorage.clear();
                window.location = "#/";
                window.location.reload();
              }}
              style={{
                float: "right"
              }}
            />
            <pr.Button
              className="secondary-btn"
              label="No"
              icon="pi pi-times"
              onClick={() => {
                this.setState({ logoutDialog: false });
              }}
              style={{
                float: "right"
              }}
            />
          </div>
        }
        visible={s.logoutDialog}
        style={{ width: "50vw" }}
        modal={true}
        onHide={e => this.setState({ logoutDialog: false })}
      >
        Are you sure you want to logout?
      </pr.Dialog>
    );
  };

  renderMenuItems(viewItems) {
    var items = [];
    var i = 0;
    viewItems.forEach(item => {
      items[i] = (
        <React.Fragment>
          &nbsp;&nbsp;
          {/* <i className="material-icons" style={{ color: "white" }}>
            {item.icon}
          </i> */}
          <span
            key={i}
            onClick={e => {
              if (item.externalLink) {
                window.open(item.externalLink);
              } else {
                this.navigateAdminOption(item.location);
              }
            }}
            style={{
              fontWeight: "normal",
              color: "white",
              textAlign: "left",
              cursor: "pointer"
            }}
          >
            {item.label}
          </span>
          <br></br>
        </React.Fragment>
      );
      i++;
    });

    return <div className="joinedList">{items}</div>;
  }
  render() {
    let topbarItemsClassName = classNames("topbar-items animated fadeInDown", {
      "topbar-items-visible": this.props.topbarMenuActive
    });
    return (
      <div className="topbar clearfix">
        {this.getLogoutDialog()}
        <div className="topbar-left">
          <img
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "100%",
              height: "100%"
            }}
            src="/assets/layout/images/business/icon.png"
            alt=""
          />
        </div>

        <div className="topbar-right">
          <a id="menu-button" onClick={this.props.onMenuButtonClick}>
            <i />
          </a>

          <a
            id="topbar-menu-button"
            onClick={this.props.onTopbarMenuButtonClick}
          >
            <i className="material-icons">menu</i>
          </a>
          <ul className={topbarItemsClassName}>
            <li
              className={classNames({
                "active-top-menu": this.props.activeTopbarItem === "settings"
              })}
            >
              <a onClick={e => this.onTopbarItemClick(e, "settings")}>
                <i className="topbar-icon material-icons">perm_identity</i>
                <span className="topbar-item-name">Settings</span>
              </a>

              <ul className="ultima-menu animated fadeInDown">
                <li>
                  <a>
                    <i className="material-icons"></i>
                    <span className="topbar-item-name">
                      {localStorage.getItem("email")}
                    </span>
                  </a>
                </li>
                <hr></hr>
                <li
                  role="menuitem"
                  onClick={() => {
                    this.setState({ visibleTop: true });
                  }}
                >
                  <a>
                    <i className="material-icons">build</i>
                    <span>Administrator Settings</span>
                  </a>
                </li>

                <li
                  role="menuitem"
                  onClick={() => {
                    this.setState({ logoutDialog: true });
                  }}
                >
                  <a>
                    <i className="material-icons">power_settings_new</i>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          className="content-section implementation"
          style={this.state.visibleTop ? {} : { display: "none" }}
        >
          <pr.Sidebar
            style={{ background: "#043066" }}
            className="ui-sidebar-lg"
            visible={this.state.visibleTop}
            position="top"
            onHide={e => this.setState({ visibleTop: false })}
          >
            <h1
              style={{
                fontWeight: "normal",
                color: "white",
                textAlign: "left"
              }}
            >
              Administration
            </h1>

            <div className="ui-g-12">
              <div className="ui-g-2" style={{ background: "#043066" }}></div>
              <div className="ui-g-2" style={{ background: "#043066" }}>
                <h2
                  style={{
                    fontWeight: "normal",
                    color: "white",
                    textAlign: "left"
                  }}
                >
                  Company
                </h2>
                <div>{this.renderMenuItems(this.state.companyItems)}</div>
              </div>
              <div className="ui-g-2" style={{ background: "#043066" }}>
                <h2
                  style={{
                    fontWeight: "normal",
                    color: "white",
                    textAlign: "left"
                  }}
                >
                  Warehouse Admin
                </h2>
                <div>{this.renderMenuItems(this.state.warehouseItems)}</div>
              </div>
              <div className="ui-g-2" style={{ background: "#043066" }}>
                <h2
                  style={{
                    fontWeight: "normal",
                    color: "white",
                    textAlign: "left"
                  }}
                >
                  Tools
                </h2>
                <div>{this.renderMenuItems(this.state.toolItems)}</div>
              </div>
            </div>
          </pr.Sidebar>
        </div>
      </div>
    );
  }
}
//   render() {
//     let topbarItemsClassName = classNames("topbar-items animated fadeInDown", {
//       "topbar-items-visible": this.props.topbarMenuActive
//     });
//     return (
//       <div>
//         {this.getLogoutDialog()}

//         <div className="topbar clearfix">
//           <div className="topbar-left">
//             <img
//               style={{
//                 display: "block",
//                 marginLeft: "auto",
//                 marginRight: "auto",
//                 width: "100%",
//                 height: "100%"
//               }}
//               src="/assets/layout/images/business/icon.png"
//               alt=""
//             />
//           </div>
//           <div className="topbar-right">
//             <a id="menu-button" onClick={this.props.onMenuButtonClick}>
//               <i />
//             </a>

//             <a
//               id="topbar-menu-button"
//               onClick={this.props.onTopbarMenuButtonClick}
//             >
//               <i className="material-icons">menu</i>
//             </a>
//             <ul className={topbarItemsClassName}>
//               {(this.props.profileMode === "top" || this.props.horizontal) && (
//                 <li
//                   className={classNames("profile-item", {
//                     "active-top-menu": this.props.activeTopbarItem === "profile"
//                   })}
//                 >
//                   <a onClick={e => this.onTopbarItemClick(e, "profile")}>
//                     <img
//                       className="profile-image"
//                       src="assets/layout/images/avatar.png"
//                       alt="Profile"
//                     />
//                     <span className="topbar-item-name">
//                       {localStorage.getItem("email")}
//                     </span>
//                   </a>

//                   <ul className="ultima-menu animated fadeInDown">
//                     <li
//                       role="menuitem"
//                       onClick={() => {
//                         logout();
//                         localStorage.clear();
//                         window.location = "#/";
//                         window.location.reload();
//                       }}
//                     >
//                       <a>
//                         <i className="material-icons">power_settings_new</i>
//                         <span>Logout</span>
//                       </a>
//                     </li>
//                   </ul>
//                 </li>
//               )}

//               <li
//                 className={classNames({
//                   "active-top-menu": this.props.activeTopbarItem === "settings"
//                 })}
//               >
//                 <a onClick={e => this.setState({ visibleTop: true })}>
//                   <i className="topbar-icon material-icons">settings</i>
//                   <span className="topbar-item-name">Settings</span>
//                 </a>

//                 <ul className="ultima-menu animated fadeInDown">
//                   <li
//                     role="menuitem"
//                     onClick={() => {
//                       logout();
//                       localStorage.clear();
//                       window.location = "#/";
//                       window.location.reload();
//                     }}
//                   >
//                     <a>
//                       <i className="material-icons">power_settings_new</i>
//                       <span>Logout</span>
//                     </a>
//                   </li>
//                 </ul>
//               </li>
//             </ul>
//           </div>
//         </div>

//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/MasterTopbar.js